import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { environment } from '@kr/environment';

import { SHELL_API, ShellApiService } from './api';
import { HeaderComponent, SidebarComponent } from './components';
import { ShellMockApi } from './mocks';
import { ShellStore } from './shell.store';

@Component({
  imports: [RouterOutlet, SidebarComponent, HeaderComponent],
  selector: 'kr-shell',
  providers: [
    {
      provide: SHELL_API,
      useClass: environment.useMocks ? ShellMockApi : ShellApiService,
    },
    ShellStore,
  ],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {}
